module.exports = __webpack_public_path__ + "img/coin.1e4a0680.png";